
import React, { useState, useEffect, useRef, useCallback } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import ProductsListComp from "./component";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import _ from "lodash";

const ProductListContainer = (props) => {
  const [loading, setLoading] = useState(true);
  const [loadingProduct, setLoadingProduct] = useState(false);
  const [brandList, setBrandList] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredItemList, setFilteredItemList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [sortDataList, setSortDataList] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [searchClicked, setSearchClicked] = useState(false);
  const [initialSearch, setInitialSearch] = useState(false);
  const [offset, setOffset] = useState(0);
  const [morescroll, setMorescroll] = useState(true);
  const [checkboxLoading, setCheckboxLoading] = useState(false);
   const [noMoreResults, setNoMoreResults] = useState(false);
  const { variantId } = useParams();
  const navigate = useNavigate();
  const tableContainerRef = useRef(null);
  const pageSize = 12;
  const location = useLocation();
  const scrollPositionRef = useRef(0);
  useEffect(() => {
    return () => {
      clearState();
    };
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearchItemList(0);
    }
  };

  const clearState = () => {
    setBrandList([]);
    setItemList([]);
    setSearchQuery("");
    setFilteredItemList([]);
    setProductList([]);
    setSortDataList([]);
    setSelectedOption("");
    setSelectedBrands([]);
    setSelectedProducts([]);
    setSelectedStatus("All");
    setSearchClicked(false);
    setInitialSearch(true);
    setOffset(0);
    setMorescroll(true);
  };

  useEffect(() => {
    if (location.state) {
      clearState();
      sessionStorage.removeItem("searchQuery");
      sessionStorage.removeItem("filteredItemList");
      sessionStorage.removeItem("brandList");
      sessionStorage.removeItem("productList");
    }
  }, [location]);

  const arrowBackClick = () => {
    navigate("/");
    clearState();
    sessionStorage.removeItem("searchQuery");
    sessionStorage.removeItem("filteredItemList");
    sessionStorage.removeItem("brandList");
    sessionStorage.removeItem("productList");
  };

  useEffect(() => {
    handleSearchItemList(0);
  }, []);

  

   useEffect(() => {
     const savedSearchQuery = sessionStorage.getItem("searchQuery");
     const savedFilteredItemList = JSON.parse(
       sessionStorage.getItem("filteredItemList")
     );
     const savedBrandList = JSON.parse(sessionStorage.getItem("brandList"));
     const savedProductList = JSON.parse(sessionStorage.getItem("productList"));

     if (savedSearchQuery) setSearchQuery(savedSearchQuery);
     if (savedFilteredItemList) setFilteredItemList(savedFilteredItemList);
     if (savedBrandList) setBrandList(savedBrandList);
     if (savedProductList) setProductList(savedProductList);

     if (
       savedSearchQuery &&
       savedFilteredItemList &&
       savedBrandList &&
       savedProductList
     ) {
       setLoading(false);
     }

     if (savedSearchQuery && savedSearchQuery.trim().length > 0) {
       setInitialSearch(false);
     }

     handleSearchItemList(0);
   }, []);

   const isSearchEmpty = searchQuery.trim().length < 3 && !initialSearch;
   const hasFilteredItems = filteredItemList && filteredItemList.length > 0;

   useEffect(() => {
     if (selectedOption) {
       handleSortItemList(0);
     }
   }, [selectedOption]);

   const handleSearchChange = (event) => {
     const { value } = event.target;
     setSearchQuery(value);
     setLoading(false);
     setOffset(0);
     setMorescroll(true);
     if (searchClicked === true && value.length > 4) {
       setSearchClicked(false);
     }
   };


   const clearAllFilters = () => {
     setSelectedBrands([]);
     setSelectedProducts([]);
     setSelectedStatus("All");

     setTimeout(() => {
       setSelectedBrands([]);
       setSelectedProducts([]);
       setSelectedStatus("All");
     }, 100);
   };



   
    const handleSearchItemList = (offsetValue = 0) => {
      const pageSize = 12;
      if (loading) return;
      const container = tableContainerRef.current;
      const previousScrollHeight = container ? container.scrollHeight : 0;
      if (searchQuery.trim().length < 3) {
        toastr.error("Error", "Please enter at least 3 characters for listing");
        setLoading(false);
        return;
      }
      setLoading(true);
      props.getDataFromAPI(
        `/partner/api/v2/productSearch/variant?variantName=${searchQuery}&productName=&brandName=&offset=${offsetValue}&limit=${pageSize}`,
        "GET",
        undefined,
        (response) => {
          setLoading(false);
          if (
            response &&
            response.variantResponse &&
            response.brandResponse &&
            response.productResponse
          ) {
            const variantList = response.variantResponse;
            const brandList = response.brandResponse;
            const productList = response.productResponse;

            if (variantList.length < pageSize) {
              setMorescroll(false);
            }

            const updatedBrandList = mergeLists(
              brandList,
              response.brandResponse
            );
            const updatedProductList = mergeLists(
              productList,
              response.productResponse
            );

            setBrandList(updatedBrandList);
            setProductList(updatedProductList);

            if (offsetValue === 0) {
              setFilteredItemList(variantList);
            } else {
              setFilteredItemList((prevState) => [
                ...prevState,
                ...variantList,
              ]);
            }

            sessionStorage.setItem("searchQuery", searchQuery);
            sessionStorage.setItem(
              "filteredItemList",
              JSON.stringify(
                offsetValue === 0
                  ? variantList
                  : [...filteredItemList, ...variantList]
              )
            );
            sessionStorage.setItem(
              "brandList",
              JSON.stringify(updatedBrandList)
            );
            sessionStorage.setItem(
              "productList",
              JSON.stringify(updatedProductList)
            );

            setOffset(offsetValue + 1);

            // Scroll to the bottom of the container
            if (container) {
              container.scrollTop = container.scrollHeight;
            }
          } else {
            console.error("Incomplete response received");
            toastr.error("Failed", "Incomplete response received");
            setFilteredItemList([]);
            setBrandList([]);
            setProductList([]);
            setMorescroll(false);
          }
        },
        (err) => {
          console.log("API Error:", err);
          toastr.error(`${("Error", err.status.message)}`, {
            position: "top-right",
            autoClose: 1000,
          });
          setLoading(false);
          setMorescroll(true);
        }
      );
    };

 

 const handleScrollApi = (offsetValue) => {
   if (loadingProduct) return;
   const formatQueryParam = (arr) => arr.join(",").replace(/&/g, "%26");
   const brandsQuery = formatQueryParam(selectedBrands);
   const productsQuery = formatQueryParam(selectedProducts);

   // Save the current scroll position
   if (tableContainerRef.current) {
     scrollPositionRef.current = tableContainerRef.current.scrollTop;
   }

   setLoadingProduct(true);
   props.getDataFromAPI(
     `/partner/api/v2/productSearch/variant?variantName=${searchQuery}&productName=${productsQuery}&brandName=${brandsQuery}&offset=${offsetValue}&limit=${pageSize}`,
     "GET",
     undefined,
     (response) => {
       setLoadingProduct(false);
       if (
         response &&
         response.variantResponse &&
         response.brandResponse &&
         response.productResponse
       ) {
         const variantList = response.variantResponse;

         if (variantList.length < pageSize) {
           setMorescroll(false);
         }

         const updatedBrandList = mergeLists(brandList, response.brandResponse);
         const updatedProductList = mergeLists(
           productList,
           response.productResponse
         );

         setBrandList(updatedBrandList);
         setProductList(updatedProductList);

         if (offsetValue === 0) {
           setFilteredItemList(variantList);
         } else {
           setFilteredItemList((prevState) => [...prevState, ...variantList]);
         }

         setOffset(offsetValue + 1);

         // Scroll to the previous saved position
         if (tableContainerRef.current) {
           tableContainerRef.current.scrollTop = scrollPositionRef.current;
         }
       } else {
         toastr.error("Failed", "Incomplete response received");
         setFilteredItemList([]);
         setBrandList([]);
         setProductList([]);
         setMorescroll(false);
       }
     },
     (err) => {
       console.log("API Error:", err);
       toastr.error("Error", err.status.message);
       setLoadingProduct(false);
       setMorescroll(true);
     }
   );
 };

useEffect(() => {
  const handleScroll = _.throttle(() => {
    const container = tableContainerRef.current;
    if (container) {
      const { scrollTop, clientHeight, scrollHeight } = container;
    
      if (
        scrollTop + clientHeight >= scrollHeight &&
        morescroll &&
        !loadingProduct

      ) {
        
        handleScrollApi(offset);
      }
    }
  }, 200);

  const container = tableContainerRef.current;
  if (container) {
    container.addEventListener("scroll", handleScroll);
  }

  return () => {
    if (container) {
      container.removeEventListener("scroll", handleScroll);
    }
  };
}, [handleScrollApi, offset, morescroll, loadingProduct, loading]);
  const handleSortItemList = (offsetValue = 0) => {
    const nextOffset = offsetValue + 1;
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v2/productSearch/variant?variantName=${searchQuery}&productName=&brandName=&isActive=&sortBy=${selectedOption}&offset=${offsetValue}&limit=${pageSize}`,
      "GET",
      undefined,
      (response) => {
        setLoading(false);
        setOffset(nextOffset);
        if (response && response.variantResponse) {
          setFilteredItemList((prevState) =>
            offsetValue === 0
              ? response.variantResponse
              : [...prevState, ...response.variantResponse]
          );

          
          if (tableContainerRef.current) {
            tableContainerRef.current.scrollTop =
              tableContainerRef.current.scrollHeight;
          }
        } else {
          setFilteredItemList([]);
        }
      },
      (err) => {
        console.log("error:", err);
        toastr.error("Failed", "Unable to fetch sort item list listing");
        setLoading(false);
      }
    );
  };

  const handleBrandCheckboxChange = (brandName) => {
    setCheckboxLoading(true);
    const updatedBrands = selectedBrands.includes(brandName)
      ? selectedBrands.filter((brand) => brand !== brandName)
      : [...selectedBrands, brandName];

    setSelectedBrands(updatedBrands);
    handleCheckBoxItemList(updatedBrands, selectedProducts);
  };

  const handleProductCheckboxChange = (productName) => {
    setCheckboxLoading(true);
    const updatedProducts = selectedProducts.includes(productName)
      ? selectedProducts.filter((product) => product !== productName)
      : [...selectedProducts, productName];

    setSelectedProducts(updatedProducts);
    handleCheckBoxItemList(selectedBrands, updatedProducts);
  };

  const handleCheckBoxItemList = (selectedBrands, selectedProducts) => {
    const formatQueryParam = (arr) => arr.join(",").replace(/&/g, "%26");

    setOffset(0);
    setMorescroll(true);

    if (selectedBrands.length === 0 && selectedProducts.length === 0) {
      handleSearchItemList(0);
      setCheckboxLoading(false);
    } else {
      setLoading(true);
      props.getDataFromAPI(
        `/partner/api/v2/productSearch/variant?variantName=${searchQuery}&productName=${formatQueryParam(
          selectedProducts
        )}&brandName=${formatQueryParam(
          selectedBrands
        )}&offset=0&limit=${pageSize}&sortBy=${selectedOption}`,
        "GET",
        undefined,
        (response) => {
          setLoading(false);
          setCheckboxLoading(false);

          if (response && response.variantResponse) {
            setFilteredItemList(response.variantResponse);

            if (response.variantResponse.length) {
              setMorescroll(false);
            }

           
            if (tableContainerRef.current) {
              tableContainerRef.current.scrollTop =
                tableContainerRef.current.scrollHeight;
            }
          } else {
            setFilteredItemList([]);
            setMorescroll(false);
          }
        },
        (err) => {
          console.log("error:", err);
          toastr.error("Failed", "Unable to fetch filtered item list");
          setLoading(false);
          setCheckboxLoading(false);
        }
      );
    }
  };

  const handleSortChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const mergeLists = (existingList, newList) => {
    const mergedList = [...existingList];

    newList.forEach((newItem) => {
      if (!existingList.some((item) => item.id === newItem.id)) {
        mergedList.push(newItem);
      }
    });

    return mergedList;
  };

  return (
    <ProductsListComp
      loading={loading}
      productList={productList}
      brandList={brandList}
      filteredItemList={filteredItemList}
      searchQuery={searchQuery}
      itemList={itemList}
      handleSearchChange={handleSearchChange}
      handleSearchItemList={handleSearchItemList}
      handleKeyPress={handleKeyPress}
      selectedOption={selectedOption}
      handleSortChange={handleSortChange}
      setFilteredItemList={setFilteredItemList}
      handleBrandCheckboxChange={handleBrandCheckboxChange}
      handleProductCheckboxChange={handleProductCheckboxChange}
      selectedStatus={selectedStatus}
      clearAllFilters={clearAllFilters}
      searchClicked={searchClicked}
      setSelectedBrands={setSelectedBrands}
      setSelectedProducts={setSelectedProducts}
      setSelectedStatus={setSelectedStatus}
      arrowBackClick={arrowBackClick}
      isSearchEmpty={isSearchEmpty}
      hasFilteredItems={hasFilteredItems}
      initialSearch={initialSearch}
      setInitialSearch={setInitialSearch}
      tableContainerRef={tableContainerRef}
      checkboxLoading={checkboxLoading}
      loadingProduct={loadingProduct}
      
    />
  );
};

function mapStateToProps(props) {
  return {
    props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(ProductListContainer);

